import { createSlice } from '@reduxjs/toolkit';
import { fetchFAQProgram } from './Utils/FAQProgramUtils';

const faqProgramSlice = createSlice({
  name: 'FAQProgram',
  initialState: {
    filters: {
      'filter[id]': '',
      'filter[question]': '',
      'filter[answer]': '',
      'filter[is_show]': '',
      'sort': '',
      'include': 'mainPrograms',
      'page': 1,
    },
    data: [],
    detail: {},
    isLoading: false,
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setDetail: (state, action) => {
      state.detail = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFAQProgram.pending, (state) => {
        // Handle loading state
        state.isLoading = true;
      })
      .addCase(fetchFAQProgram.fulfilled, (state, action) => {
        // Handle success state
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchFAQProgram.rejected, (state, action) => {
        // Handle error state
        state.isLoading = false;
        console.log(action.error.message, "error action")
      });
  }
});

export const { setFilters, setData, setDetail } = faqProgramSlice.actions;

export default faqProgramSlice.reducer;
